export default __webpack_public_path__ + "static/media/hf1.14a108e9.svg";